import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@src/@fuse/components/fullscreen';
import { FuseNavigationModule } from '@src/@fuse/components/navigation';
import { LanguagesModule } from '@app/layout/common/languages/languages.module';
import { MessagesModule } from '@app/layout/common/messages/messages.module';
import { NotificationsModule } from '@app/layout/common/notifications/notifications.module';
import { SearchModule } from '@app/layout/common/search/search.module';
import { ShortcutsModule } from '@app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from '@app/layout/common/user/user.module';
import { SharedModule } from '@app/shared/shared.module';
import { CompactLayoutComponent } from '@app/layout/layouts/vertical/compact/compact.component';

@NgModule({ exports: [
        CompactLayoutComponent
    ], imports: [RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule,
        CompactLayoutComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CompactLayoutModule
{
}
